import { ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';

export const PluginModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.pluginModule,
  templateType: ModuleTemplateTypeEnum.externalCall,
  flowType: FlowNodeTypeEnum.pluginModule,
  description: '',
  name: '',
  isTool: true,
  inputs: [], // [{key:'pluginId'},...]
  outputs: [],
};
